var exports = {
  "ST": "FavoritesChannelListContent.module__channelBadgeSelected___eEJ4OW",
  "pJ": "FavoritesChannelListContent.module__channelBadgeSelectedIcon___eEJ4OW",
  "Vm": "FavoritesChannelListContent.module__favoriteItemContainer___eEJ4OW",
  "eb": "FavoritesChannelListContent.module__favoriteItem___eEJ4OW",
  "bu": "FavoritesChannelListContent.module__favoriteItemDefault___eEJ4OW",
  "Vb": "FavoritesChannelListContent.module__favoriteItemSelected___eEJ4OW",
  "q6": "FavoritesChannelListContent.module__favoriteItemOver___eEJ4OW",
  "xQ": "FavoritesChannelListContent.module__favoriteItemMuted___eEJ4OW",
  "H": "FavoritesChannelListContent.module__avatarContainer___eEJ4OW",
  "my": "FavoritesChannelListContent.module__avatar___eEJ4OW",
  "rZ": "FavoritesChannelListContent.module__avatarPlaceholder___eEJ4OW",
  "XQ": "FavoritesChannelListContent.module__channelBadge___eEJ4OW",
  "gg": "FavoritesChannelListContent.module__channelBadgeIcon___eEJ4OW",
  "QC": "FavoritesChannelListContent.module__displayName___eEJ4OW",
  "Hq": "FavoritesChannelListContent.module__actionsContainer___eEJ4OW",
  "af": "FavoritesChannelListContent.module__categoryItem___eEJ4OW",
  "Yq": "FavoritesChannelListContent.module__categoryContent___eEJ4OW",
  "yb": "FavoritesChannelListContent.module__categoryName___eEJ4OW",
  "Yl": "FavoritesChannelListContent.module__categoryIcon___eEJ4OW",
  "wp": "FavoritesChannelListContent.module__categoryActions___eEJ4OW",
  "Ef": "FavoritesChannelListContent.module__hoverAffordance___eEJ4OW",
  "It": "FavoritesChannelListContent.module__categoryAddButton___eEJ4OW",
  "n3": "FavoritesChannelListContent.module__categoryAddButtonIcon___eEJ4OW",
  "NP": "FavoritesChannelListContent.module__navigationContainer___eEJ4OW",
  "r0": "FavoritesChannelListContent.module__channelGroupsContainer___eEJ4OW",
  "kj": "FavoritesChannelListContent.module__uncategorizedGroup___eEJ4OW",
  "Mn": "FavoritesChannelListContent.module__keyboardFocus___eEJ4OW",
};

module.exports = exports;
